<div class="login-container">
  <div class="login-content">
    <mat-card class="login-card mat-elevation-z8">


      <mat-card-content>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
          <mat-form-field appearance="outline">
            <mat-label>Kullanıcı Adı</mat-label>
            <mat-icon matPrefix class="field-icon">person_outline</mat-icon>
            <input matInput formControlName="userName" required>
            <mat-error *ngIf="loginForm.controls['userName'].invalid && 
                           (loginForm.controls['userName'].dirty || loginForm.controls['userName'].touched)">
              Kullanıcı adı giriniz
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Şifre</mat-label>
            <mat-icon matPrefix class="field-icon">lock_outline</mat-icon>
            <input matInput [type]="hidePassword ? 'password' : 'text'" 
                   formControlName="password" required>
            <button mat-icon-button matSuffix type="button"
                    (click)="hidePassword = !hidePassword"
                    [attr.aria-label]="'Şifreyi ' + (hidePassword ? 'göster' : 'gizle')"
                    [attr.aria-pressed]="!hidePassword">
              <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-error *ngIf="loginForm.controls['password'].invalid && 
                           (loginForm.controls['password'].dirty || loginForm.controls['password'].touched)">
              Şifre giriniz
            </mat-error>
          </mat-form-field>

          <div class="form-actions">
            <button mat-raised-button 
                    type="submit"
                    class="login-button"
                    style="background-color: #1976d2; color: white; border-radius: 24px;"
                    [disabled]="!loginForm.valid">
              <mat-icon>login</mat-icon>
              Giriş Yap
            </button>
          </div>
        </form>

        <div class="form-footer">
          <a class="forgot-password-link" 
             style="cursor: pointer; text-decoration: none; color: #1976d2;" 
             (click)="router.navigate(['/forgetpassword'])">
            Şifremi unuttum
          </a>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
